import { render, staticRenderFns } from "./WidgetTrophy.vue?vue&type=template&id=51f5f956&"
import script from "./WidgetTrophy.vue?vue&type=script&lang=ts&"
export * from "./WidgetTrophy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports